import React from 'react';
import { SERVER_URL } from '../services/api';
import './Modal.css';

function InvoiceViewModal({ invoice, onClose }) {
    if (!invoice) return null;

    const fileUrl = invoice.file_path ? `${SERVER_URL}/${invoice.file_path}` : null;
    const isImage = fileUrl && (fileUrl.match(/\.(jpg|jpeg|png)$/i));

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '900px', height: '90vh', display: 'flex', flexDirection: 'column' }}>
                <div className="modal-header">
                    <h2>Factura {invoice.invoice_type} - {invoice.invoice_number}</h2>
                    <button className="close" onClick={onClose}>&times;</button>
                </div>

                <div className="modal-body" style={{ flex: 1, overflow: 'hidden', padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#333' }}>
                    {fileUrl ? (
                        isImage ? (
                            <img src={fileUrl} alt="Factura" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                        ) : (
                            <iframe src={fileUrl} title="Factura PDF" style={{ width: '100%', height: '100%', border: 'none' }} />
                        )
                    ) : (
                        <div style={{ color: 'white' }}>No hay archivo adjunto disponible.</div>
                    )}
                </div>

                <div className="modal-actions">
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary" download>
                        Descargar
                    </a>
                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default InvoiceViewModal;
